import API_BASE_URL from "../config";

// Where "Renew Plan" should go: the studio's CURRENT plan, so a Pro user renews
// Pro instead of being dropped onto the Pro Max Ultra upsell they may not want
// (and whose price their wallet may not cover). The Subscribe page is driven
// entirely by the :planSlug in the URL, so the slug has to be right here.
//
// subscription_type on the storage-usage payload IS the plan slug. Falls back
// to pro_max_ultra only when it can't be read — the modal never shows for free
// accounts, so in practice a real paid slug is always present.
const FALLBACK = "pro_max_ultra";

export async function currentPlanSlug() {
  try {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");
    if (!userId || !token) return FALLBACK;
    const res = await fetch(`${API_BASE_URL}/api/users/${userId}/storage-usage`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return FALLBACK;
    const data = await res.json();
    const slug = data.subscription_type;
    return slug && slug !== "free" ? slug : FALLBACK;
  } catch {
    return FALLBACK;
  }
}

export async function renewPath() {
  return `/subscribe/${await currentPlanSlug()}`;
}
